<template>
  <nav
    class="navbar"
    :class="{ 'bg-white': showMenu, 'navbar-transparent': !showMenu }"
  >
    <b-modal
      v-if="toEditOption"
      v-model="showPopup"
      centered
      modal-class="app-popup-shell archive-popup-shell"
      dialog-class="app-popup-dialog archive-popup-dialog"
      content-class="app-popup-content archive-popup-content"
      body-class="app-popup-body archive-popup-body"
      :hide-footer="true"
      size="lg"
      title="" header-class="app-popup-header"
    >
      <div class="managerPopup archivePopupFlow">
        <div class="managerPopup-top archivePopupHead">
          <div>
            <h3 class="managerPopup-title">{{ archivePopupTitle }}</h3>
            <div class="managerPopup-subtitle">{{ archivePopupSubtitle }}</div>
          </div>
          <div class="devisPopupStageTag archivePopupStageTag">
            {{ archivePopupStageLabel }}
          </div>
        </div>

        <div class="managerPopup-card archivePopupCard">
          <div v-if="this.majmsg !== ''">
            <b-overlay
              :show="true"
              variant="white"
              rounded
              opacity="0.40"
              spinner-variant="primary"
              spinner-small
            >
              {{ this.majmsg }}
            </b-overlay>
          </div>
          <Opts
            v-if="toEditOption"
            :PID="toEditOption"
            TYPE="DD"
            :__customCB="changeEx()"
            :__preview="isChangeEx"
            :__current="this.currentArchive"
          ></Opts>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showPopupAddDevis"
      centered
      :modal-class="devisPopupModalClass"
      :dialog-class="devisPopupDialogClass"
      :content-class="devisPopupContentClass"
      :body-class="devisPopupBodyClass"
      :hide-footer="true"
      :size="devisPopupSize"
      title="" header-class="app-popup-header"
      @hidden="resetDocumentPopup"
    >
      <b-overlay
        :show="onGoingReq.length > 0"
        variant="white"
        rounded
        opacity="0.70"
        spinner-variant="primary"
        spinner-small
      >
        <div class="managerPopup devisPopupFlow">
          <div class="managerPopup-top devisPopupHead">
            <div>
              <h3 class="managerPopup-title">{{ devisPopupTitle }}</h3>
              <div class="managerPopup-subtitle">{{ devisPopupSubtitle }}</div>
            </div>
            <div class="devisPopupStageTag">
              {{ devisPopupStageLabel }}
            </div>
          </div>

          <div
            class="managerPopup-card devisPopupCard"
            :class="{ 'devisPopupCard-compact': !clientSelected }"
          >
            <ste_manager
              :isLightMode="true"
              v-if="!clientSelected"
              :onSelect="onSelectClientForDevisCb()"
            ></ste_manager>
            <devis_manager
              ref="communDevisManager"
              v-if="tempDevis !== null"
              :__item="tempDevis"
              :__admin="admin"
              :__userList="[]"
              :__isSingelton="true"
              :__isFacture="isNewFacture"
              :__isSaving="onGoingReq.length > 0"
              :__onSave="onSave"
            ></devis_manager>
          </div>
        </div>
      </b-overlay>
    </b-modal>

    <div class="mainMenu">
      <img
        :src="logoSrc"
        alt="ITTEC P&M"
        class="mainMenu-logo"
        width="150"
        height="90"
      />

      <div v-if="$route.name" class="mainMenuRoute">
        Gestion des <b class="mainMenuRoute-name">{{ $route.name }}</b>
      </div>

      <div
        class="mainMenuArchive"
        :class="{ 'mainMenuArchive-loading': !isArchiveReady }"
      >
        <span class="exercice-label">Exercice en cours :</span>
        <strong>{{ currentArchive || "..." }}</strong>
      </div>
      <b-dropdown
        id="dropdown-right"
        right
        no-caret
        boundary="viewport"
        no-flip
        menu-class="profileMenuDropdown"
        toggle-class="profileMenuToggle"
        style="float: right"
      >
        <template #button-content>
          <span class="profileMenuButtonInner">
            <span class="profileMenuButtonAvatar">
              <b-icon
                icon="person-lines-fill"
                font-scale="1.1"
              ></b-icon>
            </span>
            <span class="profileMenuButtonText">
              <span class="profileMenuButtonName">{{ admin ? admin.name : "Compte" }}</span>
              <span class="profileMenuButtonRole">{{ admin ? admin.type : "Session" }}</span>
            </span>
            <b-icon icon="chevron-down" class="profileMenuCaret"></b-icon>
          </span>
        </template>
        <div class="profileMenuSurface">
          <div class="profileMenuSummary">
            <div class="profileMenuSummaryTitle">{{ admin ? admin.name : "Compte" }}</div>
            <div class="profileMenuSummaryMeta">
              {{ admin ? admin.type : "Session" }} • Exercice {{ currentArchive }}
            </div>
          </div>

          <div class="profileMenuLayout">
            <section class="profileMenuPanel" v-if="hasNavigationItems">
              <div class="profileMenuSection">Navigation</div>
              <div class="profileMenuItemsGrid">
                <button
                  type="button"
                  @click="navigateTo('options')"
                  :class="menuItemClass('options', 'tools')"
                  v-if="canManageOptions"
                >
                  <b-icon icon="tools" class="profileMenuItemIcon"></b-icon>
                  <span>Les options</span></button
                >
                <button
                  type="button"
                  @click="openCatalogue()"
                  :class="menuItemClass('catalogue-admin', 'featured')"
                  v-if="canOpenCatalogue"
                >
                  <b-icon icon="grid-3x3-gap-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Catalogue de produits</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('products')"
                  :class="menuItemClass('products', 'default')"
                  v-if="canAccessProducts"
                >
                  <b-icon icon="box-seam" class="profileMenuItemIcon"></b-icon>
                  <span>Produits et Stock</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('services')"
                  :class="menuItemClass('services', 'default')"
                  v-if="canAccessServices"
                >
                  <b-icon icon="wrench-adjustable-circle-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Services & travaux</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('societes')"
                  :class="menuItemClass('societes', 'default')"
                  v-if="canAccessClients"
                >
                  <b-icon icon="building" class="profileMenuItemIcon"></b-icon>
                  <span>Clients et comptes</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('admins')"
                  :class="menuItemClass('admins', 'default')"
                  v-if="canAccessAdmins"
                >
                  <b-icon icon="people-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Utilisateurs et rôles</span></button
                >
                <button
                  type="button"
                  @click="openPublicCatalogue()"
                  :class="menuItemClass('/catalogue', 'featured')"
                  v-if="isClientUser"
                >
                  <b-icon icon="shop" class="profileMenuItemIcon"></b-icon>
                  <span>Retour au catalogue</span></button
                >
              </div>
            </section>

            <section class="profileMenuPanel" v-if="hasDocumentItems">
              <div class="profileMenuSection">Documents</div>
              <div class="profileMenuItemsGrid">
                <button
                  type="button"
                  @click="openDocumentPopup(false)"
                  :class="menuItemClass(null, 'accent')"
                  v-if="canCreateClientDevis"
                >
                  <b-icon icon="file-earmark-plus-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Ajouter un devis pour client</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('ddevis')"
                  :class="menuItemClass('ddevis', 'default')"
                  v-if="canViewDdevis"
                >
                  <b-icon icon="inbox-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Demandes de Devis</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('ddevis')"
                  :class="menuItemClass('ddevis', 'default')"
                  v-if="isClientUser"
                >
                  <b-icon icon="inbox-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Mes demandes de devis</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('devis')"
                  :class="menuItemClass('devis', 'default')"
                  v-if="canViewDevis"
                >
                  <b-icon icon="file-earmark-text-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Devis émis</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('devis')"
                  :class="menuItemClass('devis', 'default')"
                  v-if="isClientUser"
                >
                  <b-icon icon="file-earmark-text-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Mes devis</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('cmds')"
                  :class="menuItemClass('cmds', 'default')"
                  v-if="canViewCmds"
                >
                  <b-icon icon="cart-check-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Commandes reçues</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('cmds')"
                  :class="menuItemClass('cmds', 'default')"
                  v-if="isClientUser"
                >
                  <b-icon icon="cart-check-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Mes commandes</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('bons')"
                  :class="menuItemClass('bons', 'default')"
                  v-if="canViewBons"
                >
                  <b-icon icon="truck" class="profileMenuItemIcon"></b-icon>
                  <span>Bons de livraison</span></button
                >
                <button
                  type="button"
                  @click="openDocumentPopup(true)"
                  :class="menuItemClass(null, 'accent')"
                  v-if="canCreateClientFacture"
                >
                  <b-icon icon="receipt-cutoff" class="profileMenuItemIcon"></b-icon>
                  <span>Ajouter une facture pour client</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('factures')"
                  :class="menuItemClass('factures', 'default')"
                  v-if="canViewFactures"
                >
                  <b-icon icon="journal-text" class="profileMenuItemIcon"></b-icon>
                  <span>Les Factures</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('factures')"
                  :class="menuItemClass('factures', 'default')"
                  v-if="isClientUser"
                >
                  <b-icon icon="journal-text" class="profileMenuItemIcon"></b-icon>
                  <span>Mes factures</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('avoirs')"
                  :class="menuItemClass('avoirs', 'default')"
                  v-if="canViewAvoirs"
                >
                  <b-icon icon="arrow-counterclockwise" class="profileMenuItemIcon"></b-icon>
                  <span>Les Avoirs</span></button
                >
                <button
                  type="button"
                  @click="navigateTo('avoirs')"
                  :class="menuItemClass('avoirs', 'default')"
                  v-if="isClientUser"
                >
                  <b-icon icon="arrow-counterclockwise" class="profileMenuItemIcon"></b-icon>
                  <span>Mes avoirs</span></button
                >
              </div>
            </section>

            <section class="profileMenuPanel profileMenuPanel-wide" v-if="hasAdministrationItems">
              <div class="profileMenuSection">Administration</div>
              <div class="profileMenuItemsGrid profileMenuItemsGrid-admin">
                <button
                  type="button"
                  @click="newExercice()"
                  :class="menuItemClass(null, 'warning')"
                  v-if="canManageArchives"
                >
                  <b-icon icon="exclamation-triangle-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Clôture de l’exercice en cours</span></button
                >
                <button
                  type="button"
                  v-if="canManageArchives"
                  @click="
                    isChangeEx = true;
                    showPopup = true;
                    toEditOption = '6784308adefa389903ad4ea4';
                  "
                  :class="menuItemClass(null, 'default')"
                >
                  <b-icon icon="info-circle-fill" class="profileMenuItemIcon"></b-icon>
                  <span>Consulter exercice récent</span></button
                >
              </div>
            </section>
          </div>

          <div class="profileMenuFooter">
            <button type="button" @click="navigateTo('deconnexion')" :class="menuItemClass(null, 'logout')">
              <b-icon icon="power" class="profileMenuItemIcon"></b-icon>
              <span>Déconnexion</span></button
            >
          </div>
        </div>
      </b-dropdown>
    </div>
  </nav>
</template>
<script>
import Vue from "vue";

import { CollapseTransition } from "vue2-transitions";
import Modal from "@/components/Modal";
import ste_manager from "@/pages/societes/index";
import devis_manager from "@/pages/commun/Manager";
import Opts from "@/pages/opts/index";

export default {
  components: {
    CollapseTransition,
    Modal,
    devis_manager,
    ste_manager,
    Opts,
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      showPopupAddDevis: false,
      clientSelected: false,
      tempDevis: null,
      isNewFacture: false,
      searchQuery: "",
      admin: null,
      isChangeEx: false,
      toEditOption: null,
      showPopup: false,
      onGoingReq: [],
      currentArchive: "",
      majmsg: "",
      isArchiveReady: false,
    };
  },
  methods: {
    setCurrentArchive(ex, { emit = true } = {}) {
      const archive = String(ex || "").trim();

      if (!archive) {
        return;
      }

      this.currentArchive = archive;
      this.isArchiveReady = true;
      Vue.$cookies.set("exercice", archive);

      if (emit) {
        this.$root.$emit("archive:changed", archive);
      }
    },

    resolveDefaultArchive() {
      const archiveFromCookie = Vue.$cookies.get("exercice");

      if (archiveFromCookie) {
        this.currentArchive = String(archiveFromCookie);
        this.isArchiveReady = true;
        return;
      }

      this.setCurrentArchive(String(new Date().getFullYear()));
    },

    handleArchiveChanged(archive) {
      this.setCurrentArchive(archive, { emit: false });
    },

    createDraftDocument(owner) {
      const now = new Date().toISOString();
      return {
        createdAt: now,
        status: "NOUVEAU",
        pid: "",
        totalTTC: 0,
        totalHT: 0,
        totalTVA: 0,
        devis: [],
        owner,
        assignedTo: this.admin,
        assignedToID: this.admin._id,
        type: this.isNewFacture ? "FACTURE" : "DEVIS",
        exercice: Vue.$cookies.get("exercice"),
        numPreview: null,
      };
    },

    newExercice() {
      var d = new Date()
    if(d.getUTCMonth()<12 && this.admin.type !== "ROOT") {
      this.$bvModal
        .msgBoxConfirm("Action non autorisée avant le premier décembre", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
         
        });
      return
    }
     
      this.isChangeEx = false;
      this.showPopup = true;
      this.toEditOption = "6784308adefa389903ad4ea4";
    },

    changeEx() {
      return (ex) => {
        this.setCurrentArchive(ex);
        this.toEditOption = null;
        this.majmsg = "Mise a jour en cours ";
        setTimeout(() => {
          this.showPopup = false;
          this.majmsg = "";
        }, 10000);
      };
    },

    onSave() {
      if (this.onGoingReq.length > 0 || !this.tempDevis) {
        return;
      }

      this.onGoingReq.push({});
      let $onNext = (response) => {
        const wasNewFacture = this.isNewFacture;
        if (this.isNewFacture && response && response.data && response.data.devis) {
          this.resetStock(response.data.devis);
        }
        this.$root.$emit("documents:refresh", {
          module: this.isNewFacture ? "factures" : "devis",
        });
        this.$bvToast.toast(
          this.isNewFacture
            ? "La facture a été enregistrée avec succès."
            : "Le devis a été enregistré avec succès.",
          {
            title: this.isNewFacture ? "Facture" : "Devis",
            variant: "success",
            solid: true,
          }
        );
        this.tempDevis = null;
        this.isNewFacture = false;
        this.showPopupAddDevis = false;
        if (wasNewFacture && this.$route.path !== "/factures") {
          this.$router.push({ path: "/factures" });
        }
      };

      const $onError = () => {
        this.$bvToast.toast(
          this.isNewFacture
            ? "La facture n'a pas pu être enregistrée."
            : "Le devis n'a pas pu être enregistré.",
          {
            title: this.isNewFacture ? "Facture" : "Devis",
            variant: "danger",
            solid: true,
          }
        );
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.__.httpAction({
        methode: "POST",
        route: (this.isNewFacture) ? '/factures/' : "/devis/",
        data: this.tempDevis,
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    resetStock(stock) {
      for (var i = 0; i < stock.length; i++) {
        if (stock[i].type === "PRD") {
          this.onGoingReq.push({});
          let $onNext = (response) => {};

          const $onError = () => {};
          const $onComplete = () => {
            if (this.onGoingReq.length > 0) this.onGoingReq.pop();
          };
          this.__.httpAction({
            methode: "POST",
            route: "/prods/setstock",
            data: {_id: stock[i].id, newStock: stock[i].qte},
            onNext: $onNext,
            onError: $onError,
            onComplete: $onComplete,
          });
        }
      }
    },

    onSelectClientForDevisCb() {
      return (arg) => {
        this.clientSelected = true;
        this.askDevis({ name: arg.name, pid: arg._id });
      };
    },

    askDevis(owner) {
      this.tempDevis = this.createDraftDocument(owner);
    },

    resetDocumentPopup() {
      this.clientSelected = false;
      this.tempDevis = null;
      this.isNewFacture = false;
    },

    hideProfileMenu() {
      this.$root.$emit("bv::hide::dropdown", "dropdown-right");
    },

    openDocumentPopup(isFacture = false) {
      this.isNewFacture = isFacture;
      this.showPopupAddDevis = true;
      this.hideProfileMenu();
    },

    openCatalogue() {
      this.hideProfileMenu();
      this.$router.push({ name: "catalogue-admin" });
    },
    openPublicCatalogue() {
      this.hideProfileMenu();
      this.$router.push({ name: "catalogue" });
    },

    isCurrentRoute(identifier) {
      if (!identifier) {
        return false;
      }

      if (identifier === "catalogue-admin") {
        return (
          this.$route.name === "catalogue-admin" ||
          this.$route.path === "/superadmin/catalogue"
        );
      }

      const normalizedPath = identifier.startsWith("/")
        ? identifier
        : `/${identifier}`;

      return (
        this.$route.path === normalizedPath ||
        this.$route.path.startsWith(`${normalizedPath}/`)
      );
    },

    menuItemClass(identifier, tone = "default") {
      return [
        "profileMenuItem",
        `profileMenuItem-${tone}`,
        { "profileMenuItem-active": this.isCurrentRoute(identifier) },
      ];
    },

    navigateTo(path) {
      this.hideProfileMenu();
      if (path === "catalogue") {
        this.$router.push({ name: "catalogue-admin" });
        return;
      }
      this.$router.push("/" + path);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
  },

  computed: {
    logoSrc() {
      return require("@/assets/img/logo.gif");
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
    adminType() {
      return String(this.admin?.type || "").trim().toUpperCase();
    },
    isClientUser() {
      return this.adminType === "CLIENT";
    },
    hasNavigationItems() {
      return this.isClientUser || this.canManageOptions || this.canOpenCatalogue || this.canAccessProducts || this.canAccessServices || this.canAccessClients || this.canAccessAdmins;
    },
    hasDocumentItems() {
      return this.isClientUser || this.canCreateClientDevis || this.canViewDdevis || this.canViewDevis || this.canViewCmds || this.canViewBons || this.canCreateClientFacture || this.canViewFactures || this.canViewAvoirs;
    },
    hasAdministrationItems() {
      return this.canManageArchives;
    },
    canManageOptions() {
      return this.adminType === "ROOT";
    },
    canOpenCatalogue() {
      return ["ADMIN", "ROOT", "COMMERCIAL"].includes(this.adminType);
    },
    canAccessProducts() {
      return ["ADMIN", "ROOT", "COMMERCIAL", "TECHNIQUE", "MAGASINIER"].includes(this.adminType);
    },
    canAccessServices() {
      return ["ADMIN", "ROOT", "COMMERCIAL"].includes(this.adminType);
    },
    canAccessClients() {
      return ["ADMIN", "ROOT", "COMMERCIAL"].includes(this.adminType);
    },
    canAccessAdmins() {
      return ["ADMIN", "ROOT"].includes(this.adminType);
    },
    canCreateClientDevis() {
      return ["ADMIN", "ROOT", "COMMERCIAL"].includes(this.adminType);
    },
    canViewDdevis() {
      return ["ADMIN", "ROOT", "COMMERCIAL"].includes(this.adminType);
    },
    canViewDevis() {
      return ["ADMIN", "ROOT", "COMMERCIAL"].includes(this.adminType);
    },
    canViewCmds() {
      return ["ADMIN", "ROOT", "COMMERCIAL", "MAGASINIER"].includes(this.adminType);
    },
    canViewBons() {
      return ["ADMIN", "ROOT", "MAGASINIER"].includes(this.adminType);
    },
    canCreateClientFacture() {
      return ["ADMIN", "ROOT", "COMMERCIAL"].includes(this.adminType);
    },
    canViewFactures() {
      return ["ADMIN", "ROOT", "COMMERCIAL"].includes(this.adminType);
    },
    canViewAvoirs() {
      return ["ADMIN", "ROOT", "COMMERCIAL"].includes(this.adminType);
    },
    canManageArchives() {
      return ["ADMIN", "ROOT"].includes(this.adminType);
    },
    archivePopupTitle() {
      return this.isChangeEx
        ? "Consulter un exercice récent"
        : "Clôture de l'exercice en cours";
    },
    archivePopupSubtitle() {
      return this.isChangeEx
        ? "Retrouvez les exercices disponibles puis basculez proprement sur la période voulue."
        : "Préparez la clôture et activez l'exercice suivant dans une fenêtre harmonisée avec le reste du dashboard.";
    },
    archivePopupStageLabel() {
      return this.isChangeEx ? "Historique" : "Administration";
    },
    devisPopupModalClass() {
      return "app-popup-shell devis-popup-shell";
    },
    devisPopupDialogClass() {
      return "app-popup-dialog devis-popup-dialog";
    },
    devisPopupContentClass() {
      return "app-popup-content devis-popup-content";
    },
    devisPopupBodyClass() {
      return "app-popup-body devis-popup-body";
    },
    devisPopupSize() {
      return this.clientSelected ? "xl" : "lg";
    },
    devisPopupTitle() {
      if (!this.clientSelected) {
        return this.isNewFacture ? "Nouvelle facture client" : "Nouveau devis client";
      }
      return this.isNewFacture ? "Composer la facture" : "Composer le devis";
    },
    devisPopupSubtitle() {
      if (!this.clientSelected) {
        return this.isNewFacture
          ? "Sélectionnez d'abord le client à facturer pour ouvrir une fiche harmonisée."
          : "Sélectionnez d'abord le client pour préparer un devis dans le même format que les autres fenêtres.";
      }
      return this.isNewFacture
        ? "Renseignez les informations, ajoutez les lignes puis enregistrez la facture."
        : "Renseignez les informations, ajoutez les lignes puis enregistrez le devis.";
    },
    devisPopupStageLabel() {
      if (!this.clientSelected) {
        return "Etape 1";
      }
      return "Etape 2";
    },
    getSizePopArchive() {
      return this.$props.isLightMode
        ? "lightMode col-md-12"
        : "listeMode col-md-12";
    },
  },

  mounted() {
    this.admin = Vue.$cookies.get("user");
    this.resolveDefaultArchive();
    this.$root.$on("archive:changed", this.handleArchiveChanged);
  },

  beforeDestroy() {
    this.$root.$off("archive:changed", this.handleArchiveChanged);
  },
};
</script>
<style scoped>
:deep(.devis-popup-shell .modal-dialog) {
  max-width: 1180px !important;
}

:deep(.devis-popup-body) {
  padding-top: 12px !important;
}

:deep(.profileMenuToggle) {
  margin-top: 25px !important;
  padding: 8px 14px !important;
  min-height: 42px;
  border: 1px solid rgba(13, 29, 64, 0.14) !important;
  border-radius: 14px !important;
  background: linear-gradient(135deg, #102147 0%, #24365f 100%) !important;
  box-shadow: 0 12px 26px rgba(14, 26, 54, 0.18);
  color: #fff !important;
}

:deep(.profileMenuToggle:hover),
:deep(.profileMenuToggle:focus),
:deep(.profileMenuToggle:active),
:deep(.show > .profileMenuToggle.dropdown-toggle) {
  background: linear-gradient(135deg, #102147 0%, #1a315f 100%) !important;
  color: #fff !important;
  border-color: rgba(13, 29, 64, 0.18) !important;
  box-shadow: 0 14px 30px rgba(14, 26, 54, 0.22) !important;
}

.profileMenuButtonInner {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.profileMenuButtonAvatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
}

.profileMenuButtonText {
  display: inline-flex;
  align-items: flex-start;
  flex-direction: column;
  line-height: 1.05;
  text-align: left;
}

.profileMenuButtonName {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profileMenuButtonRole {
  font-size: 10px;
  opacity: 0.72;
  text-transform: uppercase;
}

.profileMenuCaret {
  font-size: 12px;
  opacity: 0.8;
}

:deep(.profileMenuDropdown) {
  width: min(720px, calc(100vw - 28px));
  min-width: 320px;
  padding: 0;
  border: 0;
  border-radius: 18px;
  background: transparent;
  box-shadow: none;
  overflow: visible;
}

:deep(.profileMenuDropdown .dropdown-item),
:deep(.profileMenuDropdown .b-dropdown-text) {
  padding-left: 0;
  padding-right: 0;
}

.profileMenuSurface {
  max-height: min(78vh, 760px);
  overflow-y: auto;
  padding: 12px;
  border: 1px solid rgba(186, 196, 213, 0.7);
  border-radius: 18px;
  background: linear-gradient(180deg, #f8fbff 0%, #eef3fb 100%);
  box-shadow: 0 24px 50px rgba(17, 34, 68, 0.2);
  transform-origin: top right;
  animation: profileMenuSurfaceEnter 0.18s ease-out;
}

.profileMenuSummary {
  margin-bottom: 12px;
  padding: 14px 16px !important;
  border: 1px solid rgba(179, 191, 214, 0.38);
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(233, 241, 251, 0.88) 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.profileMenuSummaryTitle {
  color: #16294b;
  font-size: 15px;
  font-weight: 800;
}

.profileMenuSummaryMeta {
  color: #6b7a96;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.profileMenuSection {
  padding: 0 !important;
  margin-bottom: 10px;
  color: #7a879d;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.profileMenuLayout {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.profileMenuPanel {
  padding: 14px;
  border: 1px solid rgba(179, 191, 214, 0.3);
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, rgba(242, 247, 252, 0.82) 100%);
  box-shadow: 0 10px 24px rgba(26, 43, 79, 0.08);
}

.profileMenuPanel-wide {
  grid-column: 1 / -1;
}

.profileMenuItemsGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.profileMenuItemsGrid-admin {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.profileMenuItem {
  display: flex !important;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  min-height: 72px;
  margin-bottom: 0;
  padding: 12px !important;
  border: 1px solid transparent;
  border-radius: 12px;
  appearance: none;
  outline: none;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  color: #223553 !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease,
    background-color 0.18s ease;
  white-space: normal;
}

.profileMenuItem:last-child {
  margin-bottom: 0;
}

.profileMenuItem:hover,
.profileMenuItem:focus {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(24, 40, 74, 0.12);
  color: #16294b !important;
}

.profileMenuItemIcon {
  flex: 0 0 auto;
  font-size: 15px;
  margin-top: 1px;
  color: #4b5f82;
}

.profileMenuItem-default {
  background: rgba(255, 255, 255, 0.92);
  border-color: rgba(176, 191, 216, 0.45);
}

.profileMenuItem-featured {
  background: linear-gradient(135deg, rgba(17, 137, 213, 0.14) 0%, rgba(29, 205, 197, 0.12) 100%);
  border-color: rgba(17, 137, 213, 0.24);
}

.profileMenuItem-tools {
  background: linear-gradient(135deg, rgba(241, 103, 125, 0.16) 0%, rgba(255, 176, 176, 0.18) 100%);
  border-color: rgba(229, 105, 126, 0.28);
}

.profileMenuItem-accent {
  background: linear-gradient(135deg, rgba(241, 133, 27, 0.15) 0%, rgba(26, 205, 205, 0.14) 100%);
  border-color: rgba(241, 133, 27, 0.28);
}

.profileMenuItem-warning {
  background: linear-gradient(135deg, rgba(255, 190, 11, 0.14) 0%, rgba(248, 119, 51, 0.12) 100%);
  border-color: rgba(240, 148, 55, 0.28);
}

.profileMenuItem-logout {
  background: linear-gradient(135deg, #ff7f50 0%, #f1851b 100%);
  border-color: rgba(208, 96, 26, 0.35);
  color: #fff !important;
}

.profileMenuItem-logout .profileMenuItemIcon {
  color: rgba(255, 255, 255, 0.92);
}

.profileMenuItem-active {
  border-color: rgba(22, 103, 214, 0.35);
  background: linear-gradient(135deg, rgba(25, 112, 224, 0.16) 0%, rgba(29, 205, 197, 0.14) 100%);
  box-shadow: 0 12px 22px rgba(32, 87, 164, 0.14);
}

.profileMenuFooter {
  position: sticky;
  bottom: -12px;
  margin-top: 12px;
  padding-top: 10px;
  background: linear-gradient(180deg, rgba(238, 243, 251, 0) 0%, rgba(238, 243, 251, 0.98) 28%);
}

.profileMenuFooter .profileMenuItem {
  min-height: 58px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  box-shadow: 0 16px 28px rgba(202, 100, 32, 0.22);
}

@keyframes profileMenuSurfaceEnter {
  0% {
    opacity: 0;
    transform: translateY(6px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.devisPopupFlow {
  gap: 16px;
}

.devisPopupHead {
  align-items: center;
}

.devisPopupStageTag {
  flex: 0 0 auto;
  padding: 8px 14px;
  border-radius: 999px;
  background: linear-gradient(135deg, #1e2a44 0%, #31415f 100%);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: 0 10px 24px rgba(30, 42, 68, 0.18);
}

.devisPopupCard {
  padding: 18px;
}

.devisPopupCard-compact {
  padding: 14px;
}

.archivePopupFlow {
  gap: 16px;
}

.archivePopupHead {
  align-items: center;
}

.archivePopupCard {
  padding: 16px;
}

.mainMenu {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: nowrap;
  width: 100%;
}

.mainMenu-logo {
  flex: 0 0 auto;
  width: 150px;
  height: 90px;
  object-fit: contain;
  background: #f1851b;
  border-radius: 12px;
}

.mainMenuRoute {
  color: #fff;
  font-size: 11px;
  padding: 10px 6px;
  text-transform: uppercase;
  flex: 1 1 auto;
  min-width: 0;
}

.mainMenuRoute-name {
  font-size: 18px;
}

.mainMenuArchive {
  color: #fff;
  font-size: 13px;
  text-align: right;
  white-space: nowrap;
}

.mainMenuArchive-loading {
  opacity: 0.72;
}

@media (max-width: 768px) {
  .devisPopupHead {
    align-items: flex-start;
  }

  .archivePopupHead {
    align-items: flex-start;
  }

  .devisPopupCard,
  .devisPopupCard-compact {
    padding: 12px;
  }

  .mainMenu {
    gap: 8px;
  }

  .mainMenu-logo {
    height: 40px !important;
    width: 84px;
  }

  .mainMenuRoute {
    padding: 4px 0;
    font-size: 10px;
  }

  .mainMenuRoute-name {
    display: block;
    font-size: 14px;
    line-height: 1.05;
  }

  :deep(.profileMenuToggle) {
    margin-top: 5px !important;
    padding: 5px 8px !important;
    font-size: 12px;
  }

  .profileMenuButtonRole,
  .profileMenuCaret {
    display: none;
  }

  .profileMenuLayout,
  .profileMenuItemsGrid,
  .profileMenuItemsGrid-admin {
    grid-template-columns: 1fr;
  }

  :deep(.profileMenuDropdown) {
    min-width: 280px;
    max-width: calc(100vw - 24px);
    width: calc(100vw - 24px);
  }

  .profileMenuSurface {
    max-height: min(80vh, 680px);
  }

  .profileMenuPanel {
    padding: 12px;
  }

  .profileMenuItem {
    min-height: 58px;
  }

  .profileMenuFooter {
    bottom: -10px;
  }
}

@media (max-width: 576px) {
  :deep(.navbar) {
    padding: 4px 8px;
    flex-wrap: nowrap;
  }

  .exercice-label {
    display: none;
  }

  .mainMenuRoute {
    display: none;
  }

  .mainMenuArchive {
    font-size: 12px;
    min-width: 0;
  }

  .profileMenuButtonName {
    max-width: 80px;
  }
}
</style>

